import { result, trim, uniqueId } from 'libraries/lodash'
import { useSelector } from 'react-redux'
import { triggerEventTarget } from 'front-end-core/helpers/document'
import { scrollTo } from 'front-end-core/services/WindowService'
import { requestReferences } from 'services/LegislationReferenceService'
import { pushEvent } from 'services/AnalyticsService'
import selectFlavour from 'redux/selectors/selectFlavour'
import selectDeviceType from 'redux/selectors/selectDeviceType'
import selectAolName from 'redux/selectors/selectAolName'

const useClickEvents = ({ pageToggleRight }) => {
  const flavour = useSelector(selectFlavour)
  const { isMobile } = useSelector(selectDeviceType)
  const aol = useSelector(selectAolName)

  const handleClick = (evt) => {
    triggerEventTarget(evt.target, {
      '.fc-legislation': (el) => {
        const ref = elementsArray(el, '.fc-reference').map(getTextContent).join(',').replace(/[^A-Z0-9:+(),\s._]/gi, '')
        requestReferences(flavour, ref, aol)
        pushEvent({ category: 'Q&A', action: 'Legislation Reference', label: ref })
        pageToggleRight(true)
      },
      'a[href]': ({ hash }) => hash && scrollTo({
        pageId: document.querySelector('.scrolling-container').id,
        id: hash,
        useWindowScrollTo: isMobile
      })
    })
  }

  const getTextContent = (el) => trim(result(el, 'textContent') || '')

  const elementsArray = (el, selector) => {
    el.id = el.id || uniqueId('temp_')
    return Array.of(...document.querySelectorAll(`#${el.id} > ${selector}`))
  }

  return { handleClick }
}

export default useClickEvents
